export default __webpack_public_path__ + "static/og-image-9a66d29e038795006fa48056c89bf56b.png";